<ng-template #matPrefix>
  @if (addonLeftVisible) {
    <span class="me-2">
      @if (currency) {
        <mat-chip-option>{{ currency }} </mat-chip-option>
      }
    </span>
  }
</ng-template>
<ng-container #fieldComponent></ng-container>
